import React from "react";
import PropTypes from "prop-types";
import { AUTH_TESTIMONIALS } from "./authTestimonials";

/**
 * Left brand card for the auth pages — a quiet, quote-first navy panel. High-
 * craft minimalism: the testimonial is the whole point, so there are no stars,
 * no avatar, no decorative quote glyph. Just the quote (with a few key phrases
 * lifted to full white) and a small, muted attribution. The navy card is the
 * page's focal object; the mint sits on the form's CTA.
 *
 * Quotes are verbatim from the brain's testimonials.md (stored as segments so
 * the emphasis can be applied without re-wording).
 */
const AuthMechanism = ({ who = "yum" }) => {
  const t = AUTH_TESTIMONIALS[who] || AUTH_TESTIMONIALS.yum;
  return (
    <aside className="auth-left-panel">
      <div className="auth-testimonial-card">
        <div className="auth-card-bg" aria-hidden="true" />
        <figure className="auth-card-content">
          <blockquote className="auth-quote">
            {t.parts.map((p, i) =>
              p.em ? (
                <span key={i} className="em">
                  {p.t}
                </span>
              ) : (
                <React.Fragment key={i}>{p.t}</React.Fragment>
              )
            )}
          </blockquote>
          <figcaption className="auth-quote-author">
            <span className="auth-quote-name">{t.name}</span>
            <span className="auth-quote-role">{t.company}</span>
          </figcaption>
        </figure>
      </div>
    </aside>
  );
};

AuthMechanism.propTypes = {
  who: PropTypes.oneOf(["mjwebs", "yum"])
};

export default AuthMechanism;
